import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import { KeyDownEvent } from '../../../../utils/eventKey';

const useCustomStyles = makeStyles((theme) => ({
    arrow: {
        color: theme.palette.common.black
    },
    tooltip: {
        textAlign: 'center',
        fontSize: 14,
        backgroundColor: theme.palette.common.black
    }
}));

const CustomTooltip = (props) => {
    const classes = useCustomStyles();

    return <Tooltip arrow classes={classes} {...props} />;
}
const OkrThreeDotMenu = ({
    id, tooltip = false, title, placement = 'bottom-end', handleKebab, menuStatus
}) => {
    const renderKebabIcon = () => (
        <button
            id={id}
            data-testid="okr-three-dot-menu"
            className="obj-dialog-three-dots-menu"
            style={{ backgroundSize: 'contain', border: 'none', backgroundColor: 'transparent' }}
            onClick={handleKebab}
            aria-expanded={menuStatus}
            aria-label="more"
            aria-controls="okr-long-menu"
            aria-haspopup="true"
        />
    )
    return (tooltip)
        ? (
            <CustomTooltip
                title={title}
                placement={placement}
            >
                {renderKebabIcon()}
            </CustomTooltip>
        )
        : renderKebabIcon()
}

export default OkrThreeDotMenu;
